<template>
  <div class="artwork__table-data mt-0 mb-3">
    <div v-if="userWithLimitOrder">
      <span class="title">
        {{ I18n.t('artworks.your_limit') }}
      </span>
      <span class="price">
        {{ I18n.t("price_with_currency", { price: formatPrice(artwork.currentUserOrder.limit) }) }}
      </span>
    </div>
    <div v-if="userWithPhoneOrder">
      <span class="title">
        {{ I18n.t('artworks.your_contact') }}
      </span>
      <span class="price">
        {{ this.artwork.currentUserOrder.phone }}
      </span>
    </div>
  </div>
</template>

<script>
  import { formatNumber } from '@/shared/helpers';

  export default {
    name: 'OrderDetails',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    computed: {
      userWithLimitOrder() {
        return this.artwork.currentUserOrder.limit !== null;
      },
      userWithPhoneOrder() {
        return this.artwork.currentUserOrder.phone !== '';
      },
    },
    created() {
      this.formatPrice = formatNumber;
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/orders/order_details.vue?54719795